/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Section_Audio_DescriptionInputs */



/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {Options_Editor_Section_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_section_audio_description = /** @type {((inputs?: Options_Editor_Section_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Section_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Audiodescription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиоописание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição em áudio")
	return /** @type {LocalizedString} */ ("Audio Description")
});